import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../SignIn/HealthCareSign.scss";
import Spinner from "../../../components/Spinner/Spinner";
import { EntraExchange } from "../../../utils/apiCalls/auth";
import { setSession } from "../../../services/auth";
import { useToast } from "../../../utils/ToastContext";

const FAILED = "Microsoft sign-in failed. Please try again.";

// Landing page for the BE redirect after Entra SSO (/auth/callback?code=...
// or ?error=sso_failed). Entra already did MFA, so there's no OTP step: the
// exchange returns the same payload as ValidateMfaOtp and is stored the same way.
const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { showToast } = useToast();
  // The code is single-use: never post it twice (StrictMode double effects).
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const code = searchParams.get("code");
    const error = searchParams.get("error");
    // Get the code out of the address bar / history before anything else.
    window.history.replaceState(window.history.state, "", "/auth/callback");

    const fail = (message) => {
      showToast(message || FAILED, "error");
      navigate("/", { replace: true });
    };

    if (error || !code) {
      fail();
      return;
    }

    EntraExchange(code)
      .then(({ statusCode, data, message }) => {
        if (statusCode !== 200 || !data?.accessToken) {
          fail(message);
          return;
        }
        const loginType = data.userId === 1 ? 1 : 2;
        setSession({
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
          userData: data,
          loginType,
        });
        navigate(loginType === 1 ? "/admin-dashboard" : "/hp-dashboard", { replace: true });
      })
      .catch((err) => fail(err?.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="hcsignin">
      <div className="loader-container" role="status">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
          <Spinner />
          <p>Signing you in…</p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
